import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject, IEgeExamSubject } from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import { GET_EGE_EXAM_SUBJECTS_REF } from '../actions';

export type EgeExamSubjectsRefState = ICommonResponseObject<IEgeExamSubject[]>;

const initialState: EgeExamSubjectsRefState = {
  content: [],
  loading: false,
};
const generic = genericReducers<EgeExamSubjectsRefState>();
const egeExanSubjectsRef: IReducers<EgeExamSubjectsRefState> = {
  [GET_EGE_EXAM_SUBJECTS_REF[REQUEST]]: generic.get.request,
  [GET_EGE_EXAM_SUBJECTS_REF[SUCCESS]]: generic.get.success,
  [GET_EGE_EXAM_SUBJECTS_REF[FAILURE]]: generic.get.failure,
  [GET_EGE_EXAM_SUBJECTS_REF[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, egeExanSubjectsRef);
